var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57337 15.6661L10.7858 7.7753C11.1844 7.3392 11.3837 7.12115 11.6437 7.04791C11.8705 6.98403 12.1295 6.98403 12.3563 7.04791C12.6163 7.12115 12.8156 7.3392 13.2142 7.7753L20.4266 15.6661C20.8267 16.1037 21.0267 16.3226 20.9971 16.5022C20.9714 16.6588 20.8418 16.8012 20.6406 16.8938C20.4101 17 20.0108 17 19.2124 17H4.7876C3.98916 17 3.58994 17 3.35935 16.8938C3.15823 16.8012 3.02865 16.6588 3.00286 16.5022C2.9733 16.3226 3.17332 16.1037 3.57337 15.6661Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAscending);
export default __webpack_public_path__ + "static/media/arrow-ascending.cc300597d6df8ef2306d5d6868b26639.svg";
export { ForwardRef as ReactComponent };